<template>
  <div :style="backgroundColor" class="floatingButton">
    <div @click="$emit('validate')" class="button">
      <v-icon font-size="3em">{{ icon }}</v-icon>
    </div>
    <div class="label-container">
      <div class="label-text">Envoyer</div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'floatingButton',
    props: {
      color: {
        type: String,
        default: ''
      },
      icon: {
        type: String,
        default: ''
      }
    },

    computed: {
      backgroundColor() {
        return { backgroundColor: this.color }
      }
    }
  }
</script>

<style lang="scss" scoped>

  .button {
    position: absolute;
    width: 60px;
    height: 60px;
    bottom: 17px;
    right: 17px;
    background-color: #44DA72;
    color: #FFF;
    border-radius: 50px;
    text-align: center;
    box-shadow: 2px 2px 3px #CDCACA;
    cursor: pointer;
    @include display-flex(center, center, row);
  }

  .label-container {
    position: absolute;
    bottom: 27px;
    right: 85px;
    display: table;
    visibility: hidden;
  }

  .label-text {
    color: #FFF;
    background: rgba(51, 51, 51, 0.5);
    display: table-cell;
    vertical-align: middle;
    padding: 10px;
    border-radius: 3px;
    font-family: $secondary-font;
  }

  .button + div.label-container {
    visibility: hidden;
    opacity: 0;
    transition: visibility 0s, opacity 0.5s ease;
  }

  .button:hover + div.label-container {
    visibility: visible;
    opacity: 1;
  }
</style>
